import { render, staticRenderFns } from "./messagesource.vue?vue&type=template&id=569aebfc&"
import script from "./messagesource.vue?vue&type=script&lang=ts&"
export * from "./messagesource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('569aebfc')) {
      api.createRecord('569aebfc', component.options)
    } else {
      api.reload('569aebfc', component.options)
    }
    module.hot.accept("./messagesource.vue?vue&type=template&id=569aebfc&", function () {
      api.rerender('569aebfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messagesource.vue"
export default component.exports